<template>
  <q-page padding>
    <PageHeader
      title="Acompanhamento Integração Ficha EPI"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs items-end"
    >
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="q-ml-sm texto-titulo-input">Requisição ID</div>
        <q-input
          v-model.number="filtros.requestId"
          type="number"
          class="input"
          dense
          outlined
          min="1"
          clearable
        />
      </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="q-ml-sm texto-titulo-input">Enviado</div>
        <q-select
          :options="options.enviado"
          dense
          outlined
          class="select"
          v-model="filtros.enviado"
          emit-value
          map-options
        />
      </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="q-ml-sm texto-titulo-input">Erro</div>
        <q-select
          :options="options.erro"
          dense
          outlined
          class="select"
          v-model="filtros.erro"
          emit-value
          map-options
        />
      </div>

      <div class="col-md-auto col-sm-6 col-xs-12">
        <q-btn
          class="q-mt-xs btn"
          color="primary"
          label="Filtrar"
          style="margin-bottom: 3px"
          no-caps
          icon="filter_alt"
          :disable="loading"
          @click="aplicarFiltro"
        />
      </div>
    </div>

    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Arquivos Enviados ao GED (Ficha EPI)
        </span>
      </div>

      <q-table
        :columns="columns"
        :rows="rows"
        :loading="loading"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        @request="paginarTabela"
        :rows-per-page-label="'Linhas Por Página'"
        v-model:pagination="pagination"
        :rows-per-page-options="[10, 15, 25, 50, 100]"
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div class="row col-12">
                <span class="row col-12 q-mt-sm"
                  ><strong class="q-mr-xs">ID:</strong>{{ props.row.id }}</span
                >
                <span class="row col-12 q-mt-sm"
                  ><strong class="q-mr-xs">Requisição ID:</strong
                  >{{ props.row.requisicaoId }}</span
                >
                <span class="row col-12 q-mt-sm"
                  ><strong class="q-mr-xs">Arquivo:</strong>
                  <a
                    v-if="props.row.urlArquivo"
                    :href="props.row.urlArquivo"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link-arquivo"
                  >
                    Abrir arquivo
                  </a>
                  <span v-else></span>
                </span>
                <span class="row col-12 q-mt-sm"
                  ><strong class="q-mr-xs">Enviado:</strong
                  >{{ props.row.enviado }}</span
                >
                <span class="row col-12 q-mt-sm"
                  ><strong class="q-mr-xs">Erro:</strong
                  >{{ props.row.erro }}</span
                >
                <span class="row col-12 q-mt-sm"
                  ><strong class="q-mr-xs">Mensagem:</strong
                  >{{ props.row.mensagemErro || "-" }}</span
                >
                <span class="row col-12 q-mt-sm"
                  ><strong class="q-mr-xs">Data envio:</strong
                  >{{ formatDateTime(props.row.createdAt) }}</span
                >
                <span class="row col-12 q-mt-sm"
                  ><strong class="q-mr-xs">Data atualização:</strong
                  >{{ formatDateTime(props.row.updatedAt) }}</span
                >

                <div class="row col-12 q-mt-md q-gutter-sm">
                  <q-btn
                    icon="visibility"
                    round
                    color="primary"
                    :disable="!hasStackTrace(props.row.stackTrace)"
                    @click="abrirDetalhe(props.row)"
                  >
                    <q-tooltip>Detalhe (Stack Trace)</q-tooltip>
                  </q-btn>
                  <q-btn
                    icon="arrow_upward"
                    round
                    color="positive"
                    :disable="loading || Number(props.row.erro) === 0"
                    @click="reenviar(props.row)"
                  >
                    <q-tooltip>Reenviar</q-tooltip>
                  </q-btn>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>

        <template v-slot:body-cell-requisicaoId="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.requisicaoId }}
          </q-td>
        </template>

        <template v-slot:body-cell-urlArquivo="props">
          <q-td class="text-brand-5" :props="props">
            <a
              v-if="props.row.urlArquivo"
              :href="props.row.urlArquivo"
              target="_blank"
              rel="noopener noreferrer"
              class="link-arquivo"
            >
              Abrir arquivo
            </a>
            <span v-else></span>
          </q-td>
        </template>

        <template v-slot:body-cell-enviado="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.enviado }}
          </q-td>
        </template>

        <template v-slot:body-cell-erro="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.erro }}
          </q-td>
        </template>

        <template v-slot:body-cell-mensagemErro="props">
          <q-td class="text-brand-5" :props="props">
            {{ props.row.mensagemErro || "-" }}
          </q-td>
        </template>

        <template v-slot:body-cell-stackTrace="props">
          <q-td :props="props">
            <q-btn
              icon="visibility"
              round
              flat
              color="primary"
              :disable="!hasStackTrace(props.row.stackTrace)"
              @click="abrirDetalhe(props.row)"
            >
              <q-tooltip>Detalhe (Stack Trace)</q-tooltip>
            </q-btn>
          </q-td>
        </template>

        <template v-slot:body-cell-reenviar="props">
          <q-td :props="props">
            <q-btn
              icon="arrow_upward"
              round
              color="positive"
              :disable="loading || Number(props.row.erro) === 0"
              @click="reenviar(props.row)"
            >
              <q-tooltip>Reenviar</q-tooltip>
            </q-btn>
          </q-td>
        </template>

        <template v-slot:body-cell-createdAt="props">
          <q-td class="text-brand-5" :props="props">
            {{ formatDateTime(props.row.createdAt) }}
          </q-td>
        </template>

        <template v-slot:body-cell-updatedAt="props">
          <q-td class="text-brand-5" :props="props">
            {{ formatDateTime(props.row.updatedAt) }}
          </q-td>
        </template>
      </q-table>
    </div>

    <q-dialog v-model="detalheDialog">
      <q-card style="width: 1100px; max-width: 90vw; min-height: 45vh">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Stack Trace da Integração</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <q-input
            v-model="detalheStackTrace"
            type="textarea"
            readonly
            autogrow
            outlined
            class="stacktrace-input"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import PageHeader from "../../../../components/PageHeader.vue";

const columns = [
  { name: "id", label: "ID", align: "left" },
  { name: "requisicaoId", label: "Requisição ID", align: "left" },
  { name: "urlArquivo", label: "Arquivo", align: "left" },
  { name: "enviado", label: "Enviado", align: "left" },
  { name: "erro", label: "Erro", align: "left" },
  {
    name: "mensagemErro",
    label: "Mensagem Processamento",
    align: "left",
  },
  { name: "createdAt", label: "Data de Envio", align: "left" },
  { name: "updatedAt", label: "Data Atualização", align: "left" },
  { name: "stackTrace", label: "Detalhe", align: "center" },
  { name: "reenviar", label: "Reenviar", align: "center" },
];

export default {
  components: { PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const loading = ref(false);
    const rows = ref([]);

    const detalheDialog = ref(false);
    const detalheStackTrace = ref("");

    const pagination = ref({
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 0,
    });

    const filtros = ref({
      requestId: null,
      enviado: null,
      erro: null,
    });

    const options = {
      enviado: [
        { label: "Todos", value: null },
        { label: "Não", value: 0 },
        { label: "Sim", value: 1 },
      ],
      erro: [
        { label: "Todos", value: null },
        { label: "Sem erro", value: 0 },
        { label: "Com erro", value: 1 },
      ],
    };

    const hasStackTrace = (stackTrace) => {
      return Boolean(stackTrace && String(stackTrace).trim());
    };

    const formatDateTime = (value) => {
      if (!value) return "-";
      const [datePart, timePart] = String(value).split(" ");
      if (!datePart) return value;
      const [year, month, day] = datePart.split("-");
      if (!year || !month || !day) return value;
      return `${day}/${month}/${year}${timePart ? ` ${timePart}` : ""}`;
    };

    const montarParams = (page, rowsPerPage) => {
      const params = {
        perPage: rowsPerPage,
        page,
      };

      if (filtros.value.requestId) {
        params.requestId = filtros.value.requestId;
      }

      if (filtros.value.enviado !== null) {
        params.enviado = filtros.value.enviado;
      }

      if (filtros.value.erro !== null) {
        params.erro = filtros.value.erro;
      }

      return params;
    };

    const listar = async (
      page = 1,
      rowsPerPage = pagination.value.rowsPerPage
    ) => {
      try {
        loading.value = true;
        const response = await store.dispatch(
          "integracao/listarIntegracaoFichaEpi",
          montarParams(page, rowsPerPage)
        );

        const results = response?.data?.results || {};
        rows.value = Array.isArray(results.data) ? results.data : [];
        pagination.value.page = Number(results.currentPage) || page;
        pagination.value.rowsPerPage = Number(results.perPage) || rowsPerPage;
        pagination.value.rowsNumber = Number(results.total) || 0;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao carregar acompanhamento de integração da ficha EPI",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        loading.value = false;
      }
    };

    const aplicarFiltro = () => {
      pagination.value.page = 1;
      listar(1, pagination.value.rowsPerPage);
    };

    const paginarTabela = ({ pagination: tablePagination }) => {
      listar(tablePagination.page, tablePagination.rowsPerPage);
    };

    const abrirDetalhe = (row) => {
      detalheStackTrace.value = hasStackTrace(row.stackTrace)
        ? row.stackTrace
        : "Sem stack trace disponível";
      detalheDialog.value = true;
    };

    const reenviar = async (row) => {
      if (Number(row.erro) === 0) return;

      try {
        loading.value = true;
        const response = await store.dispatch(
          "integracao/reprocessarIntegracaoFichaEpi",
          {
            requisicaoId: row.requisicaoId,
          }
        );

        const message =
          response?.data?.results?.message ||
          "O reprocessamento será feito em background.";

        quasar.notify({
          message,
          color: "positive",
          actions: [{ label: "Fechar", color: "white" }],
        });

        await listar(pagination.value.page, pagination.value.rowsPerPage);
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao solicitar reprocessamento da ficha EPI",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      listar();
    });

    return {
      columns,
      rows,
      loading,
      pagination,
      filtros,
      options,
      detalheDialog,
      detalheStackTrace,
      hasStackTrace,
      formatDateTime,
      listar,
      aplicarFiltro,
      paginarTabela,
      abrirDetalhe,
      reenviar,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.link-arquivo {
  color: var(--q-primary);
  text-decoration: underline;
  word-break: break-all;
}

.stacktrace-input :deep(textarea) {
  font-family: monospace;
  font-size: 12px;
  line-height: 1.4;
  min-height: 35vh;
}

@media (max-width: 600px) {
  .container-inputs {
    margin: 0;
  }

  .texto-titulo-input {
    font-size: 12px;
    margin: 0;
  }

  .input,
  .select,
  .btn,
  .texto-titulo-tabela {
    font-size: 12px;
  }

  .texto-titulo-tabela {
    margin: 0 0 0 6px;
  }

  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }

  .text-grid-table {
    font-size: 12px;
  }
}
</style>
